import { stripNoteAnchors } from './paragraphAnchors'

/**
 * Strips anything unsafe or private out of a published story's stored HTML before it is rendered.
 *
 * Kept in its own module rather than beside the view that calls it: this is the client-side
 * backstop for the publish leak, it has its own test file, and a module that exports both a
 * component and a plain function loses Fast Refresh.
 */
export function sanitizePublishedHtml(html: string): string {
  // Rows published before the server-side strip existed (getFullStoryContent, index.ts) still
  // carry whatever data-note anchors were there at publish time, and republishing is the
  // author's choice, not the app's — this is the only thing that cleans those existing rows.
  const documentCopy = new DOMParser().parseFromString(stripNoteAnchors(html), 'text/html')
  documentCopy
    .querySelectorAll('script, style, iframe, object, embed, link, meta')
    .forEach((node) => {
      node.remove()
    })
  documentCopy.querySelectorAll('*').forEach((node) => {
    for (const attribute of Array.from(node.attributes)) {
      const name = attribute.name.toLowerCase()
      const value = attribute.value.trim().toLowerCase()
      if (
        name.startsWith('on') ||
        ((name === 'href' || name === 'src') && value.startsWith('javascript:'))
      ) {
        node.removeAttribute(attribute.name)
      }
    }
  })
  return documentCopy.body.innerHTML
}
